import { render } from "./pb-estimation.vue?vue&type=template&id=b6d236ac"
import script from "./pb-estimation.vue?vue&type=script&lang=js"
export * from "./pb-estimation.vue?vue&type=script&lang=js"

import "./pb-estimation.vue?vue&type=style&index=0&id=b6d236ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__